import EditProductBlock from './EditProductBlock';

export default EditProductBlock;
